'use strict';
import isDate from 'lodash/isDate';
import isNumber from 'lodash/isNumber';


export const timeOffset = 12 * 60 * 60 * 1000; // match the time handling of non-useTime schedule dates

export const NOT_SCHEDULED = 'not_scheduled';
export const COMPLETE = 'complete';
export const CANCELLED = 'cancelled';
export const SCHEDULED = 'scheduled';
export const IMMINENT = 'imminent';
export const PAST_DUE = 'past_due';

export const APPROVED = 'approved';

export function getScheduleStatus(task) {
  if (!task)
    return NOT_SCHEDULED;
  const now = new Date().getTime();
  let due;
  const scheduled = isDate(task.scheduled) ? task.scheduled.getTime() : task.scheduled;
  if (task.status === 'submitted' || task.status === 'approved') {
    return COMPLETE;
  } else if (task.status === 'cancelled') {
    return CANCELLED;
  } else if (isNumber(scheduled)) {

    // TODO: improve this. Verify if this accounts for time zones correctly.
    due = task.useTime ? scheduled : scheduled + timeOffset - 1;

    if (now < due - 2 * timeOffset) {
      return SCHEDULED;
    } else if (now < due) {
      return IMMINENT;
    } else {
      return PAST_DUE;
    }

  } else {
    return NOT_SCHEDULED;
  }
}

export function canStartTimer(status) {
  return status !== APPROVED && status !== CANCELLED;
}

export const canEditChildProp = model => model ? !model.task : true;



// WEBPACK FOOTER //
// ./src/js/tasks/domain/utils.js